import createSagaMiddleware from '@redux-saga/core';
import { applyMiddleware, compose, createStore } from 'redux';
import { ItineraryApiClient } from '../api/itinerary';
import { AppState } from './model';
import rootReducer, { rootSaga } from './reducers';
import { confirmDialogInitialState } from './reducers/confirm-dialog/reducer';
import { initialState } from './reducers/itinerary/reducer';
import { segmentDetailsInitialState } from './reducers/segment-details/reducer';
import { segmentOptionsInitialState } from './reducers/segment-options/reducer';
import { selectedOptionsInitialState } from './reducers/selected-options/reducer';
import { selectedRateInitialState } from './reducers/selected-rate/reducer';
import { selectedSegmentInitialState } from './reducers/selected-segment/reducer';
import { MetricsApiClient } from '../api/metrics';

function _configureStore(
  initalState: AppState,
  webApiUrl: string,
  metricApiUrl: string,
): any {
  // compose enhancers
  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers =
    ((window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
      })) ||
    compose;

  // create api
  const api = new ItineraryApiClient(webApiUrl);
  const metricApi = new MetricsApiClient(metricApiUrl);

  // create store
  const store = createStore(
    rootReducer,
    initalState,
    composeEnhancers(applyMiddleware(sagaMiddleware)),
  );

  // run the sagas
  sagaMiddleware.run(rootSaga, { api, metricApi });

  return store;
}

const state: AppState = {
  itinerary: initialState,
  selectedOptions: selectedOptionsInitialState,
  selectedSegment: selectedSegmentInitialState,
  confirmDialog: confirmDialogInitialState,
  segmentDetails: segmentDetailsInitialState,
  segmentOptions: segmentOptionsInitialState,
  selectedRate: selectedRateInitialState,
};

function configureStore(webApiUrl: string, metricApiUrl: string) {
  return _configureStore(state, webApiUrl, metricApiUrl);
}

export default configureStore;
